import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-paymentpopup',
  imports: [],
  templateUrl: './paymentpopup.component.html',
  styleUrl: './paymentpopup.component.scss'
})
export class PaymentpopupComponent {

  constructor(private http: HttpClient, public dialogRef: MatDialogRef<PaymentpopupComponent>) {}

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  closePaymentPopup() {
    this.dialogRef.close()
  }

  purchaseCredits(credits: number) {
    console.log(credits)
  }

}
